import withTranslation from 'utils/react/withTranslation';

import Header from './Header';

export default withTranslation()(Header);
